var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑品牌信息" : "新增品牌信息",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "100px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "品牌名称：",
                    prop: "brandName",
                    rules: [
                      {
                        required: true,
                        message: "请填写品牌名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写品牌名称" },
                    model: {
                      value: _vm.pram.brandName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "brandName", $$v)
                      },
                      expression: "pram.brandName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "状态",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择状态",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌logo", prop: "brandLogo" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: {
                            click: function ($event) {
                              return _vm.modalPicTap("1", "brandLogo")
                            },
                          },
                        },
                        [
                          _vm.pram.brandLogo
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.pram.brandLogo },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.pram.brandLogo
                        ? _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red", "font-size": "16px" },
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("brandLogo")
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌简介", prop: "brandRemark" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请填写品牌简介",
                    },
                    model: {
                      value: _vm.pram.brandRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "brandRemark", $$v)
                      },
                      expression: "pram.brandRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }